import {
  Component,
  AfterContentInit,
  OnDestroy
} from '@angular/core';
import {
  TenderAdmissionStatusCodeDTO,
  TenderStateDTOV2,
  TenderV2DTO
} from '../../api/plyca-dtos';
import { UserPrefs } from '../../api/UserPrefs-dto';
import { UIService, DossierDTOModal } from '../../ui.service';
import { DossierService } from '../dossier.service';
import {
  Subscription,
  forkJoin
} from '../../../../node_modules/rxjs';
import {
  ProcurementProjectDTO,
  AwardDTO,
  ProcurementProjectLotDTO,
  AwardLotDTO,
  ValidationResultDTO,
  ResultTypeDTO,
  ValidationExecutionDTO
} from '../../api/plyca-dtos-v2';
import { TranslateService } from '@ngx-translate/core';
import { awardEditionComponent } from './awardEdition.component';
import { awardCreationComponent } from './awardCreation.component';
import { Configuration } from '../../conf/app.constants';
import { TaskHandler } from '../../tasks/TaskHandler';
import { HeaderActionsService } from '../../components/common/sub-header/header-actions.service';
import { ServiceLocator } from '../../ServiceLocator';
import { PlycaErrorHandler } from '../../../http/PlycaErrorHandler';
import { DialogService, DynamicDialogConfig } from 'primeng-lts/dynamicdialog';
// import { DATE_FORMAT_PRIMENG, LanguageService } from '../../../services/language.service';
import * as lodash from 'lodash';
import { take } from 'rxjs/operators';
import { PRIMENG_DATE_FORMAT, LanguageService } from '../../../services/language.service';
import { AwardDeclaraNoAdjComponent } from './awardDeclaraNoAdj.component';
@Component({
  selector: 'awardsList',
  templateUrl: 'awardsList.template.html',
  providers: [DialogService]
})

// tslint:disable-next-line:class-name
export class awardsListComponent extends TaskHandler
  implements AfterContentInit, OnDestroy {
  // INFORMACION DEL EXPEDIENTE
  dossierId: string;
  project: ProcurementProjectDTO;

  awardsLoaded = false;
  awardsList: Array<AwardDTO>;
  tendersList: Array<TenderV2DTO>;
  //  filteredAwardsList: Array<AwardDTO>;
  pendingLots: Array<ProcurementProjectLotDTO>;
  rejectedLots: Array<ProcurementProjectLotDTO>;

  avalaibleLots: Array<ProcurementProjectLotDTO>;

  // INFORMACION DE LA PANTALLA ALMACENADA EN SESION
  userPrefsSubs: Subscription;
  userPrefs: UserPrefs;
  dossier: any;
  infoLoaded = false;
  allowDeleted = true;
  allowInsert = true;
  warrantiesRegistered = false;
  showRejectedDate = false;
  lotSelected: ProcurementProjectLotDTO;
  contadorContratos: any;
  awardsAvailables: any;

  ResultType = ResultTypeDTO;
  // datos modal validacion
  public showValidationInfo = false;
  public validationAward: AwardDTO;

  public translationService: TranslateService;
  public PRIMENG_DATE_FORMAT = PRIMENG_DATE_FORMAT;
  dateRejected: any;

  fechaBuscada = undefined;

  constructor(

    public uiService: UIService,
    public dossierService: DossierService,
    public configuration: Configuration,
    private headerActionsService: HeaderActionsService,
    private plycaErrorHandler: PlycaErrorHandler,
    private languageService: LanguageService,
    public dialogService: DialogService
  ) {
    super();
    this.dialogService = ServiceLocator.injector.get(DialogService);
    this.translationService = ServiceLocator.injector.get(TranslateService);

    // route.params.subscribe(params => {
    //   this.dossierId = params['id'];
    // });
  }

  ngAfterContentInit(): void {
    this.loadData();
    // Activación del botón borrar
    this.allowDeleted = true;
    if (this.task.work && this.task.work.context && this.task.work.context.configurations
      && this.task.work.context.configurations.allowDeleted) {
      this.allowDeleted = this.task.work.context.configurations.allowDeleted.value;
    }
    // Activación del botón insertar
    this.allowInsert = true;
    if (this.task.work && this.task.work.context && this.task.work.context.configurations
      && this.task.work.context.configurations.allowInsert) {
      this.allowInsert = this.task.work.context.configurations.allowInsert.value;
    }



    this.infoLoaded = true;
    this.subscribe(this.headerActionsService.addAction(
      'AwardInfo.buttonDesert',
      'fa fa-lg fa-times',
      'btn-primary',
      function () {
        return (this.project && !this.project.breakdownLot.apportioned && !this.project.breakdownLot.totalLots.rejectedLot
          && this.pendingLots && this.pendingLots.length > 0)
      }.bind(this)
    ), success => {
      // this.loteDesierto(undefined);
      this.declaraNOAdj(undefined, false);
    });
    this.subscribe(this.headerActionsService.addAction(
      'AwardInfo.buttonReactivate',
      'far fa-arrow-alt-circle-up',
      'btn-primary',
      function () {
        return (this.project && !this.project.breakdownLot.apportioned
          && this.project.breakdownLot.totalLots.rejectedLot && !this.isFechaObligatoria(this.project.breakdownLot.totalLots))
      }.bind(this)
    ), success => {
      this.reactivarLote(undefined);
    });
    this.subscribe(this.headerActionsService.addAction(
      'AwardInfo.buttonNew',
      'fas fa-plus',
      'btn-primary',
      function () {
        return (this.allowInsert && (this.pendingLots && this.pendingLots.length > 0)
          || (!this.pendingLots && this.awardsList && this.awardsList.length === 0))
      }.bind(this)
    ), success => {
      this.openAward(this.pendingLots);
    });
    this.subscribe(this.headerActionsService.addAction(
      'General.accept',
      'fa fa-lg fa-check',
      'btn-primary',
      true
    ), success => {
      this.volver();
    });

  }

  loadData(): void {
    //    this.awardsLoaded = false;
    this.waitService.startWaiting();
    // this.loading.next(new LoadingInfo(true));
    this.dossierId = this.task.division.project.identifier;
    if (this.task.work.context.configurations.awardsAvailables) {
      this.awardsAvailables = this.task.work.context.configurations.awardsAvailables.value;
    }
    this.subscribe(forkJoin(
      //this.plycaService.getProcurementProjectWithLot(this.dossierId),
      this.plycaService.getProcurementProject(this.dossierId, '?expand=expansionSet:BASIC_LOT_COFINANCIEDLINE'),
      this.plycaService.getDossierAwards(this.dossierId),
      this.plycaService.query<TenderV2DTO>(
        this.configuration.TENDER_SERVICE_V2_URL,
        { projectEntityIdentifier: this.dossierId }
      )
    ), result => {
      // 1. recuperar información del expediente
      this.project = result[0];

      // 2. recuperar contratos
      if (result[1]) {
        this.awardsList = result[1].content;
      } else {
        this.awardsList = [];
      }

      if (result[2]) {
        this.tendersList = result[2].content;
      } else {
        this.tendersList = [];
      }

      // 3. filtrar la lista de lotes pendientes de adjudicar
      // Variable que indica si se permite adjudicar un lote a más de un contrato
      let awardMultiplesLots = false;
      if (this.task.work && this.task.work.context && this.task.work.context.configurations
        && this.task.work.context.configurations.awardMultiplesLots) {
        awardMultiplesLots = this.task.work.context.configurations.awardMultiplesLots.value;
      }
      if (this.project && this.project.breakdownLot.apportioned) {
        if (this.project.breakdownLot.lots) {
          this.pendingLots = this.project.breakdownLot.lots.filter(lote => {
            let countAward = 0;
            let countTender = 0;
            let award;

            // Si awardMultiplesLots==false-> Entonces si encuentras el lote en un contrato se considera adjudicado.
            if (awardMultiplesLots) {
              // Si awardMultiplesLots==true-> Hay que comprobar que el número de ofertas en el que aparece
              // el lote corresponde con el número de contratos en los que está el lote.

              countAward = this.awardsList.filter(awardTmp =>
                awardTmp.awardsLots.filter(awardLot => awardLot.projectLot.lotId === lote.lotId).length > 0).length;

              countTender = this.tendersList.filter(tenderTmp =>
                tenderTmp.document.currentState.identifier !== TenderStateDTOV2.REJECTED
                && tenderTmp.tenderLots && tenderTmp.tenderLots.filter(tenderLot =>
                  tenderLot.tenderEvaluation.admissionStatus.statusCode === TenderAdmissionStatusCodeDTO.ACEPTED
                  && tenderLot.procurementProjectLot.lotId === lote.lotId).length > 0).length;
              console.log(
                'Buscando lote ',
                lote.lotId,
                ' en ' + countAward + ' adjudicaciones y en ' + countTender + ' ofertas'
              );

              return (countAward == 0 || countAward !== countTender);
            } else if (this.awardsList !== undefined && this.awardsList.length > 0) {
              award = this.awardsList.find(awardTmp => {
                let filteredAward = awardTmp.awardsLots.filter(awardLot => {
                  console.log(
                    'comparando ',
                    awardLot.projectLot.lotId,
                    lote.lotId
                  );
                  return awardLot.projectLot.lotId === lote.lotId;
                });
                console.log(
                  'filteredAward',
                  filteredAward,
                  filteredAward !== undefined
                );
                return filteredAward.length > 0;
              });
            }
            console.log(
              'Buscando lote ',
              lote,
              ' en las adjudicaciones: ',
              award
            );
            return award === undefined;

          });
          console.log('PENDING LOTS ENCONTRADOS: ', this.pendingLots);
        } else {
          this.pendingLots = [];
        }
      } else {
        this.pendingLots = [];
        let award;
        if (!awardMultiplesLots && (this.awardsList !== undefined && this.awardsList.length > 0
          && !this.project.breakdownLot.totalLots.rejectedLot)) {
          let lote = this.project.breakdownLot.totalLots;
        } else {
          if (!this.project.breakdownLot.totalLots.rejectedLot) {
            this.pendingLots.push(this.project.breakdownLot.totalLots);
          }
        }

      }

      this.avalaibleLots = this.pendingLots.filter(lote => !lote.rejectedLot && this.isLotavailable(lote));
      if (this.project && this.project.breakdownLot.apportioned) {
        this.rejectedLots = this.pendingLots.filter(lote => lote.rejectedLot);
        if (this.rejectedLots !== undefined && this.rejectedLots.length > 0) {
          this.rejectedLots.forEach((rejectedLot: ProcurementProjectLotDTO) => {
            let lotRejected = new AwardDTO();
            lotRejected.awardDate = rejectedLot.rejectedDate;
            lotRejected.desierto = true;

            let awardLot = new AwardLotDTO();
            let projectLot = new ProcurementProjectLotDTO()
            awardLot.projectLot = rejectedLot;
            lotRejected.awardsLots = [];
            lotRejected.awardsLots.push(awardLot);
            this.awardsList.push(lotRejected);
          });
        }
      } else if (this.project.breakdownLot.totalLots.rejectedLot) {
        let lotRejected = new AwardDTO();
        lotRejected.awardDate = this.project.breakdownLot.totalLots.rejectedDate;
        lotRejected.desierto = true;

        let awardLot = new AwardLotDTO();
        let projectLot = new ProcurementProjectLotDTO()
        awardLot.projectLot = this.project.breakdownLot.totalLots;
        lotRejected.awardsLots = [];
        lotRejected.awardsLots.push(awardLot);
        this.awardsList.push(lotRejected);
      }
      this.pendingLots = this.pendingLots.filter(lote => !lote.rejectedLot);
      this.contadorContratos = 0;
      this.awardsList.forEach((award: AwardDTO) => {
        if (!award.desierto) {
          this.contadorContratos++;
        }
      });


      //      this.awardsLoaded = true;
      this.waitService.cancelWaiting();
      // this.loading.next(new LoadingInfo(false));

      this.awardsList.filter(award => !award.desierto).forEach(award => this.validateAward(award));
    });
  }

  isAwardMultiplesLots(): boolean {
    if (this.task && this.task.work && this.task.work.context
      && this.task.work.context.configurations
      && this.task.work.context.configurations.awardMultiplesLots
      && this.task.work.context.configurations.awardMultiplesLots.value) {
      return this.task.work.context.configurations.awardMultiplesLots.value;
    } else {
      return false;
    }
  }

  // public isLoading(): Observable<LoadingInfo | boolean> {
  //   return this.loadingObservable;
  // }

  ngOnDestroy(): void {
    this.headerActionsService.clearActions();
    super.ngOnDestroy();
  }

  openAward(params: any) {
    let award = params !== undefined ? params.award : undefined;
    let lot = params !== undefined ? params.lot : undefined;
    let lot0;
    console.log('ABRIENDO CONTRATO', award, lot);
    let context = new DossierDTOModal(this.dossier);
    let header = 'Alta de contrato';

    let component;
    // si llega contrato
    if (award) {
      header = this.translateService.instant('AwardInfo.awardEdit');
      component = awardEditionComponent;
    } else if (lot) {
      // si llega lota
      header = this.translateService.instant('AwardInfo.editAwardLot') + ' ' + lot.lotNumber + ': ' + lot.description;
      component = awardCreationComponent;
    } else {
      context['selectedLots'] = this.pendingLots;
      header = this.translateService.instant('AwardInfo.newAward.title');
      component = awardCreationComponent;
    }
    let config: DynamicDialogConfig = {
      header: header,
      width: '90%',
      styleClass: 'formEdition'

    };
    if (award) {
      context['awardId'] = award.identifier;
    }
    if (!award && params[0] !== undefined && params[0].lotId !== undefined && params[0].lotId === 0) {
      lot0 = params[0];
    }

    context['lot'] = lot;
    context['lot0'] = lot0;
    console.log('project:' + this.project.identifier);
    context['project'] = this.project;
    context['pendingLots'] = this.pendingLots;
    context['tendersList'] = this.tendersList;
    context['awardsList'] = this.awardsList;
    context['taskWork'] = this.task.work;
    context['isExpConGastoCofinanciado'] = this.task.work.context.configurations !== undefined
      && this.task.work.context.configurations.isExpConGastoCofinanciado !== undefined ?
      this.task.work.context.configurations.isExpConGastoCofinanciado.value : undefined;

    context['isRelatedProject'] = this.project.relatedProject;

    config.data = {
      task: this.task
    };
    console.log('OPENAWARD, CONTEXT', context);
    config['context'] = context;
    this.waitService.startWaiting();
    const dialog = this.dialogService.open(component, config);

    dialog.onClose.pipe(take(1)).subscribe(newaward => {
      //Cuando se cree un nuevo contrato y esté informada la variable ADJ_MODIFICABLES
      //es necesario añadir ese contrato a la variable para que se pueda editar el
      //contrato creado. Esto es muy necesario en subsaciones donde borran un contrato para
      //crear otro asociado a una nueva empresa y la división no se borra por el contrato ya
      //tenga documentación asociada.
      if (this.awardsAvailables && newaward) {
        this.awardsAvailables.push(newaward.identifier);
      }
      this.loadData();
    });
  }

  removeAward(award: AwardDTO) {
    this.uiService.showConfirmMessage({
      message: this.translateService.instant('AwardInfo.messages.deleteContract'),
      header: this.translateService.instant('General.confirmtext'),
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.subscribe(this.plycaService
          .delete<AwardDTO>(
            this.configuration.AWARD_SERVICE_URL,
            award.identifier
          ),
          () => {
            console.log('AWARD ELIMINADO');
            this.loadData();
          },
          error => {
            console.log('INSERT AWARD ERROR', error);
            this.plycaErrorHandler.showServerError(error);
            // if (error.errors) {
            //   let errores: Array<ValidationExecutionDTO> = error.errors;
            //   let strMessage = '';
            //   errores.forEach((err: ValidationExecutionDTO) => {
            //     strMessage += err.message;
            //   });
            //   this.uiService
            //     .showMessage(strMessage).onClose.subscribe();
            // }
          });
      },
      reject: () => {
        console.log('ELIMINACIÓN CANCELADA');
      }
    });
  }

  validateAward(award: AwardDTO) {
    if (award.desierto) {
      award.awardsLots.forEach(awardLot => {
        this.fechaBuscada = undefined;
        if (this.isFechaObligatoria(awardLot.projectLot) && this.lotesATratar(awardLot.projectLot)
          && awardLot.projectLot.rejectedDate === undefined) {
          if (!award['validation']) {
            let validation = new ValidationResultDTO;
            validation.result = ResultTypeDTO.ERROR;
            let valError = new ValidationExecutionDTO;
            valError.message = this.translateService.instant('AwardInfo.desertLotValidation');
            validation.errors = [];
            validation.errors.push(valError);
            award['validation'] = validation;
          }
        }
      });
    } else {
      console.log('INICIO VALIDATEAWARD');
      if (this.task && this.task.work) {
        award.context = this.task.work.context;
      }
      let tmpAward: any;
      tmpAward = lodash.cloneDeep(award);
      console.log('antes de limpiar', award, tmpAward);
      // limpiar variables de apoyo de tablas
      tmpAward = JSON.parse(
        JSON.stringify(tmpAward, (k, v) => (k === '_parent' ? undefined : v))
      );

      this.subscribe(this.plycaService.validate(this.configuration.AWARD_SERVICE_URL, 'Update', tmpAward),
        (validation: ValidationResultDTO) => {
          if (validation.result === ResultTypeDTO.ERROR || validation.result === ResultTypeDTO.WARNING) {
            award['validation'] = validation;
          }
        },
        error => {
          console.log('UPDATE AWARD ERROR', error);
        }
      );
    }
  }

  public showValidationResult(award: AwardDTO): void {
    this.showValidationInfo = true;
    this.validationAward = award;
  }

  public closeValidationResult(): void {
    this.showValidationInfo = false;
    this.validationAward = undefined;
  }


  /*reactivarLote(award: AwardDTO) {
    let projectWithoutLots = false;
    let lote;
    if (award === undefined) {
      lote = this.project.breakdownLot.totalLots;
    } else {
      lote = award.awardsLots[0].projectLot;
      if (lote.lotId === undefined) {
        projectWithoutLots = true;
        lote = this.project.breakdownLot.totalLots;
        lote.rejectedLot = false;
      }
    }
    this.uiService.showConfirmMessage({
      message: projectWithoutLots ? (lote.rejectedLot ? this.translateService.instant('AwardInfo.messages.messageReactivateProject') :
        this.translateService.instant('AwardInfo.messages.messageDesertProject')) : lote.rejectedLot ?
          this.translateService.instant('AwardInfo.messages.messageReactivateLot') :
          this.translateService.instant('AwardInfo.messages.messageDesertLots'),
      header: this.translateService.instant('General.confirmtext'),
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        lote.rejectedLot = false;
        lote.rejectedDate = null;
        console.log('REACTIVAR LOTE');
        this.subscribe(this.plycaService
          .updateProjectLotDesert(
            lote,
            this.dossierId
          ),
          () => {
            console.log('EL LOTE SE HA MARCADO COMO DESIERTO');
            this.loadData();
          });
      },
      reject: () => {
        console.log('ELIMINACIÓN CANCELADA');
      }
    });
  }*/

  fechaDesierto(award: AwardDTO) {
    let projectWithoutLots = false;


    if (this.isFechaObligatoria(award.awardsLots[0].projectLot)) {
      // this.showRejectedDate = true;
      this.lotSelected = award.awardsLots[0].projectLot;
    } else if (this.lotesATratar(award.awardsLots[0].projectLot)) {
      // this.showRejectedDate = true;
      this.lotSelected = award.awardsLots[0].projectLot;
    } else {
      this.subscribe(this.plycaService
        .updateProjectLotDesert(
          award.awardsLots[0].projectLot,
          this.dossierId
        ),
        () => {
          console.log('EL LOTE SE HA MARCADO COMO DESIERTO');
          this.loadData();
        });
    }
  }

  reactivarLote(award: AwardDTO) {
    let projectWithoutLots = false;
    let lote;
    if (award === undefined) {
      lote = this.project.breakdownLot.totalLots;
    } else {
      lote = award.awardsLots[0].projectLot;
      if (lote.lotId === undefined) {
        projectWithoutLots = true;
        lote = this.project.breakdownLot.totalLots;
        lote.rejectedLot = false;
      }
    }
    this.declaraNOAdj(lote, true);
  }

  declaraNOAdj(lote: ProcurementProjectLotDTO, reactivarLote: boolean) {
    let projectWithoutLots = false;
    if (lote === undefined) {
      projectWithoutLots = true;
      lote = this.project.breakdownLot.totalLots;
    }

    if (lote.rejectedLot && reactivarLote) {
      lote.rejectedLot = false;
      lote.nonAwardResolutionType = undefined;
      lote.nonAwardResolutionReason = undefined;
      lote.textNonAwardResolutionReason = undefined;
      lote.rejectedDate = undefined;

      this.subscribe(this.plycaService
        .updateProjectLotDesert(
          lote,
          lote.parent.identifier
        ),
        () => {
          console.log('EL LOTE SE HA MARCADO COMO NO RESUELTO ADJUDICACIÓN.');
          this.loadData();
        });
    } else {
      // lote.rejectedLot = true;
      let header = 'Declarar No Adjudicación';

      header = this.translateService.instant('AwardInfo.awardDeclaraNoAdj.title');
      let component = AwardDeclaraNoAdjComponent;

      let config: DynamicDialogConfig = {
        header: header,
        width: this.isFechaObligatoria(lote) ? '60%' : '40%',

        style: { overflow: 'scroll' },
        styleClass: 'formEdition',
        data: lote
      };
      config['isFechaObligatoria'] = this.isFechaObligatoria(lote);
      this.waitService.startWaiting();

      const dialog = this.dialogService.open(component, config);
      this.subscribe(

        dialog.onClose
        ,
        result => {
          this.loadData();
        }

      )

      this.waitService.cancelWaiting();
    }


  }

  loteDesierto(lote: ProcurementProjectLotDTO) {
    let projectWithoutLots = false;
    if (lote === undefined) {
      projectWithoutLots = true;
      lote = this.project.breakdownLot.totalLots;
    }

    this.uiService.showConfirmMessage({
      message: projectWithoutLots ? (lote.rejectedLot ? this.translateService.instant('AwardInfo.messages.messageReactivateProject') :
        this.translateService.instant('AwardInfo.messages.messageDesertProject')) : lote.rejectedLot ?
        this.translateService.instant('AwardInfo.messages.messageReactivateLot') :
        this.translateService.instant('AwardInfo.messages.messageDesertLots'),
      header: this.translateService.instant('General.confirmtext'),
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        lote.rejectedLot = true;
        this.subscribe(this.plycaService
          .updateProjectLotDesert(
            lote,
            this.dossierId
          ),
          () => {
            console.log('EL LOTE SE HA MARCADO COMO DESIERTO');
            this.loadData();
          });

      },
      reject: () => {
        console.log('ELIMINACIÓN CANCELADA');
      }
    });
  }

  getStateDescription(award: AwardDTO) {
    switch (AwardDTO.getState(award)) {
      case AwardDTO.AWARDSTATE_PENDING:
        return this.translateService.instant('AwardInfo.STATE_PENDING');
      case AwardDTO.AWARDSTATE_AWARDED:
        return this.translateService.instant('AwardInfo.STATE_AWARDED');
      case AwardDTO.AWARDSTATE_FORMALIZED:
        return this.translateService.instant('AwardInfo.STATE_FORMALIZED');
      case AwardDTO.AWARDSTATE_DESISTIDO:
        return this.translateService.instant('AwardInfo.STATE_DESISTIDO');
      case AwardDTO.AWARDSTATE_DESIERTO:
        // return this.translateService.instant('AwardInfo.STATE_DESIERTO');
        if (award.awardsLots[0].projectLot && award.awardsLots[0].projectLot.nonAwardResolutionType) {
          if (award.awardsLots[0].projectLot.nonAwardResolutionType.description) {
            return award.awardsLots[0].projectLot.nonAwardResolutionType.description;
          } else {
            return this.getStringID(award.awardsLots[0].projectLot.nonAwardResolutionType.identifier);
          }
        }
    }
  }

  getStringID(identifier: string) {
    let des = '';
    if (typeof identifier === 'string' && identifier.indexOf('<>') !== -1) {
      des = identifier.toString().substring(0, identifier.indexOf('<'));
    }
    return des;
  }

  getStateIcon(award: AwardDTO) {
    switch (AwardDTO.getState(award)) {
      case AwardDTO.AWARDSTATE_PENDING:
        return 'fa-pause text-secondary';
      case AwardDTO.AWARDSTATE_AWARDED:
        return 'fa-thumbs-up text-info';
      case AwardDTO.AWARDSTATE_FORMALIZED:
        return 'fa-handshake-o text-success';
      case AwardDTO.AWARDSTATE_DESISTIDO:
        return 'fa-thumbs-down text-danger';
      case AwardDTO.AWARDSTATE_DESIERTO:
        return 'fa-ban text-danger';
    }
  }

  volver() {
    // uiService.routeBack()
    let fechaObligatoria = false;
    let fechasObligNoValid = false;
    this.fechaBuscada = undefined;
    this.awardsList.forEach((award: AwardDTO) => {
      award.awardsLots.forEach((awardLot: AwardLotDTO) => {
        if (this.isFechaObligatoria(awardLot.projectLot) && awardLot.projectLot.rejectedDate === undefined) {
          fechaObligatoria = true;
        } else if (this.lotesATratar(awardLot.projectLot)) {
          fechasObligNoValid = true;
        }
      });
    });
    let awardListFilter = this.awardsList.filter(award => award.desierto != true);
    this.task.work.awards = awardListFilter;
    //this.task.work.awards = this.awardsList;

    if (!fechaObligatoria && !fechasObligNoValid) {
      this.processTask(true);
    } else {
      if (fechaObligatoria) {
        this.uiService.showMessage(this.translateService.instant('AwardInfo.desertLotValidation'), 'General.info')
          .onClose.pipe(take(1)).subscribe(() => {
            this.salir()
          });
      }

      if (fechasObligNoValid) {
        this.uiService.showMessage(this.translateService.instant('AwardInfo.desertDateValid'), 'General.info')
          .onClose.pipe(take(1)).subscribe(() => {
            this.salir()
          });
      }

      /*this.uiService.showConfirmMessage({
        message: 'Debe informarse la fecha de declaración de desiertos de los lotes que lo precisen.',
        header: this.translateService.instant('General.confirmtext'),
        icon: 'pi pi-exclamation-triangle',
        accept: () => {
          console.log('ELIMINACIÓN CANCELADA');
        },
        reject: () => {
          this.salir();
        }
      });*/
    }
  }

  isInfoLoaded(): boolean {
    return this.infoLoaded;
  }

  isAwardEditAllowed() {
    let resultado = true;
    if (this.task.work && this.task.work.context && this.task.work.context.configurations
      && this.task.work.context.configurations.modIsAllowed) {
      resultado = this.task.work.context.configurations.modIsAllowed.value;
    }
    return resultado;
  }

  awardHasLotEditAllowed(award: AwardDTO) {
    let resultado = false;
    if (this.task.work && this.task.work.context && this.task.work.context.configurations
      && this.task.work.context.configurations.lotsAvailables
      && this.task.work.context.configurations.lotsAvailables.value
      && this.task.work.context.configurations.lotsAvailables.value.length > 0) {
      if (award.awardsLots != null && award.awardsLots.length > 0) {
        award.awardsLots.forEach((lot: AwardLotDTO) => {
          if (lot.projectLot && lot.projectLot.lotId !== 0) {
            this.task.work.context.configurations.lotsAvailables.value.forEach((id: ProcurementProjectLotDTO) => {
              if (id.lotId === 0 || id.lotId === lot.projectLot.lotId) {
                resultado = true;
              }
            });
          } else {
            resultado = true;
          }
        });
      }
    } else {
      resultado = true;
    }
    return resultado;
  }

  isAwardAvailable(award: AwardDTO) {
    let resultado = true;
    //if (this.awardsAvailables) {
    //let awardsAvailableList = this.task.work.context.configurations.awardsAvailables.value;
    if (this.awardsAvailables !== undefined && this.awardsAvailables.length > 0) {
      let _resultado = false;
      this.awardsAvailables.forEach((id: String) => {
        if (id === award.identifier) {
          _resultado = true;
        }
      });
      return _resultado;
    }
    //}
    return resultado;
  }

  isLotavailable(_lot: ProcurementProjectLotDTO) {
    if (this.task.work && this.task.work.context && this.task.work.context.configurations &&
      this.task.work.context.configurations.lotsAvailables) {
      let lotsAvailableList = this.task.work.context.configurations.lotsAvailables.value;
      if (lotsAvailableList !== undefined && lotsAvailableList.length > 0) {
        let resultado = false;
        lotsAvailableList.forEach((lot: ProcurementProjectLotDTO) => {
          if (_lot && (lot.lotId === _lot.lotId)) {
            resultado = true;
          }
        });
        return resultado;
      }
    }
    return true;
  }

  isDesertLotAvailable(_lot: ProcurementProjectLotDTO) {
    return this.awardsList.filter(award => award.awardsLots
      .filter(awardLot => awardLot.projectLot.lotId == _lot.lotId).length > 0).length == 0;
  }

  checkWarrantiesRegistered(award: AwardDTO) {
    return award.warranties !== undefined && award.warranties.length > 0;
  }

  public newCommunication(): void {
    let lote = this.lotSelected;
    if (this.lotSelected === undefined) {
      lote = this.project.breakdownLot.totalLots;
    }
    lote.rejectedDate = this.dateRejected;
    this.fechaBuscada = undefined;
    if (this.isFechaObligatoria(lote) && lote.rejectedDate === undefined) {
      this.uiService.showMessage(this.translateService.instant('AwardInfo.desertLotValidation'), 'General.info')
    } else if (this.lotesATratar(lote)) {
      this.uiService.showMessage(this.translateService.instant('AwardInfo.desertDateValid'), 'General.info')
    } else {
      this.subscribe(this.plycaService
        .updateProjectLotDesert(
          lote,
          this.dossierId
        ),
        () => {
          console.log('EL LOTE SE HA MARCADO COMO DESIERTO');
          this.loadData();
          // this.showRejectedDate = false;
        });
    }
  }

  public isFechaObligatoria(lote: ProcurementProjectLotDTO) {
    let fechaObligatoria = false;
    if (this.task.work && this.task.work.context && this.task.work.context.configurations
      && this.task.work.context.configurations.rejectedLotsRequired !== undefined) {
      let rejectedLotsList = this.task.work.context.configurations.rejectedLotsRequired.value;
      if (rejectedLotsList !== undefined && rejectedLotsList.length > 0) {
        fechaObligatoria = rejectedLotsList.find(rejectedLot => rejectedLot.lotId === lote.lotId) !== undefined;
      }
    }
    return fechaObligatoria;
  }

  public lotesATratar(lote: ProcurementProjectLotDTO) {
    if (this.fechaBuscada === undefined) {
      this.fechaBuscada = lote.rejectedDate;
    } else {
      if (lote.rejectedDate && lote.rejectedDate.getTime() !== this.fechaBuscada.getTime()) {
        return true;
      } else {
        return false;
      }
    }

  }

}
